export const defaultTimes = {
  EIGHT: '08:00',
  EIGHTTEEN: '18:00',
}
